import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '@app/shared/components/base/base.component';

@Component({
  selector: 'app-boolean-toggle',
  templateUrl: './boolean-toggle.component.html',
  styleUrls: ['./boolean-toggle.component.scss']
})
export class BooleanToggleComponent extends BaseComponent
                                    implements OnInit {

  @Input()
  public inputLabel: string;

  @Input()
  set trueFalseNull(trueFalseNullValue: boolean) {
    this._selectedValue = trueFalseNullValue === true ? 'true' : (trueFalseNullValue === false ? 'false' : 'null');
  }

  @Output()
  public trueFalseNullChange = new EventEmitter();

  private _selectedValue: string;

  get selectedValue(): string {
    return this._selectedValue;
  }

  set selectedValue(newValue: string) {
    this._selectedValue = newValue;
    const emitValue = this._selectedValue === 'true' ? true : (this._selectedValue === 'false' ? false : null);
    this.trueFalseNullChange.emit(emitValue);
  }
  
  constructor() {
    super();
  }

  public ngOnInit() {
  }
}
